// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"20cd7108","703":"4767820b","787":"003980ab"}[chunkId] + ".chunk.js";
};